(function () {
  function parseBoolean(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    return String(value).toLowerCase() === 'true';
  }

  function initFeaturedCollectionsSelector(root) {
    if (!root || root.dataset.selectorInitialized === 'true') return;
    root.dataset.selectorInitialized = 'true';

    const selected = new Map();
    const listEl = root.querySelector('[data-fc-selector-list]');
    const emptyEl = root.querySelector('[data-fc-selector-empty]');
    const totalEl = root.querySelector('[data-fc-selector-total]');
    const continueBtn = root.querySelector('[data-fc-selector-continue]');
    const simDialog = root.querySelector('[data-fc-sim-dialog]');
    const checkoutDialog = root.querySelector('[data-fc-checkout-dialog]');
    const checkoutDialogListEl = root.querySelector('[data-fc-checkout-modal-list]');
    const checkoutDialogTotalEl = root.querySelector('[data-fc-checkout-modal-total]');
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const fallbackCurrencyCode = root.dataset.currencyCode || 'EUR';
    const continueLabel = root.dataset.continueLabel || 'Continuar';
    const chooseButtonLabel = root.dataset.chooseLabel || 'Elegir este producto';
    const chooseButtonSelectedLabel = root.dataset.chooseSelectedLabel || 'Producto elegido';
    const shouldClearCartBeforeContinue = parseBoolean(root.dataset.clearCartBeforeContinue, true);
    const routesFallback = root.dataset.routesFallback || '/';
    const modalImageFallback = root.dataset.modalImgFallback || '';

    let pendingAddBtn = null;

    function cartPath(endpoint) {
      const rootPath =
        typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root
          : routesFallback || '/';
      const base = String(rootPath).replace(/\/?$/, '/');
      return base + String(endpoint).replace(/^\//, '');
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
          style: 'currency',
          currency: fallbackCurrencyCode || 'EUR'
        }).format(cents / 100);
      } catch (e) {
        return `${(cents / 100).toFixed(2)} ${fallbackCurrencyCode || 'EUR'}`;
      }
    }

    function toCents(value) {
      return Number(value || 0);
    }

    function getButtonProductData(btn) {
      const variantId = btn.dataset.variantId;
      const title = btn.dataset.productTitle || 'Producto';
      const productName = btn.dataset.productName || title;
      const unitPrice = toCents(btn.dataset.productPrice);
      return {
        key: variantId,
        variantId,
        title,
        productName,
        unitPrice,
        image: btn.dataset.productImage || '',
        popupBullets: btn.dataset.productPopupBullets || '',
        lines: [{ id: variantId, quantity: 1 }]
      };
    }

    function extractBulletLines(rawBullets, fallbackLines) {
      const fallback = Array.isArray(fallbackLines) ? fallbackLines.filter(Boolean) : [];
      if (!rawBullets) return fallback;

      const bulletLines = [];
      const extractRichTextBullets = (node) => {
        if (!node) return;
        if (Array.isArray(node)) {
          node.forEach(extractRichTextBullets);
          return;
        }
        if (typeof node !== 'object') return;

        if (node.type === 'list-item' && Array.isArray(node.children)) {
          const line = node.children
            .map((child) => (child && typeof child.value === 'string' ? child.value : ''))
            .join('')
            .trim();
          if (line) bulletLines.push(line);
        }

        if (Array.isArray(node.children)) extractRichTextBullets(node.children);
      };

      const raw = String(rawBullets).trim();
      if (raw.startsWith('{') || raw.startsWith('[')) {
        try {
          const parsed = JSON.parse(raw);
          extractRichTextBullets(parsed);
        } catch (e) {
          // fallback
        }
      }

      if (!bulletLines.length) {
        raw
          .split(/\r?\n|\|/g)
          .map((line) => line.trim())
          .filter(Boolean)
          .forEach((line) => bulletLines.push(line));
      }

      return bulletLines.length ? bulletLines : fallback;
    }

    function totalCents() {
      let total = 0;
      selected.forEach((item) => {
        total += item.price;
      });
      return total;
    }

    function cartPayloadItems() {
      const items = [];
      selected.forEach((item) => {
        if (item.lines && item.lines.length) {
          item.lines.forEach((line) => {
            const row = { id: Number(line.id), quantity: line.quantity || 1 };
            if (line.sellingPlan) {
              const sp = Number(line.sellingPlan);
              if (sp) row.selling_plan = sp;
            }
            items.push(row);
          });
        } else {
          items.push({ id: Number(item.variantId), quantity: 1 });
        }
      });
      return items;
    }

    function buildSimSelectionKey(variantId, simId, sellingPlan) {
      return `${variantId}::sim:${simId || 'none'}::plan:${sellingPlan || 'none'}`;
    }

    function hasSelectionForVariant(variantId) {
      if (!variantId) return false;
      for (const item of selected.values()) {
        if (String(item.variantId) === String(variantId)) return true;
      }
      return false;
    }

    function render() {
      listEl.innerHTML = '';
      selected.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'fc-selector-cart__line text-sm';

        if ((item.quantity || 1) > 1) {
          const qty = document.createElement('span');
          qty.className = 'fc-selector-cart__qty';
          qty.textContent = String(item.quantity);
          li.appendChild(qty);
        }

        const mediaWrap = document.createElement('div');
        mediaWrap.className = 'fc-selector-cart__media';
        const img = document.createElement('img');
        img.className = 'fc-selector-cart__thumb';
        img.src = item.image || '';
        img.alt = item.title;
        mediaWrap.appendChild(img);

        const content = document.createElement('div');
        content.className = 'fc-selector-cart__content';

        const titleSpan = document.createElement('p');
        titleSpan.className = 'fc-selector-cart__item-title';
        titleSpan.textContent = item.title;

        const bulletsEl = document.createElement('ul');
        bulletsEl.className = 'fc-selector-cart__bullets';
        (item.bullets || []).forEach((line) => {
          const bullet = document.createElement('li');
          bullet.textContent = line;
          bulletsEl.appendChild(bullet);
        });

        const meta = document.createElement('div');
        meta.className = 'fc-selector-cart__meta';
        const priceSpan = document.createElement('span');
        priceSpan.textContent = formatMoney(item.price || 0);
        const rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'button button--xs';
        rm.setAttribute('data-fc-selector-remove', item.key || item.variantId);
        rm.textContent = 'Quitar';

        meta.appendChild(priceSpan);
        meta.appendChild(rm);
        content.appendChild(titleSpan);
        if (bulletsEl.childElementCount) content.appendChild(bulletsEl);
        content.appendChild(meta);

        li.appendChild(mediaWrap);
        li.appendChild(content);
        listEl.appendChild(li);
      });

      const hasItems = selected.size > 0;
      emptyEl.style.display = hasItems ? 'none' : '';
      totalEl.textContent = formatMoney(totalCents());
      continueBtn.disabled = !hasItems;

      root.querySelectorAll('[data-fc-selector-add]').forEach((btn) => {
        const variantId = btn.dataset.variantId;
        const isSelected = hasSelectionForVariant(variantId);
        btn.textContent = isSelected ? chooseButtonSelectedLabel : chooseButtonLabel;
        btn.classList.toggle('is-selected', isSelected);
        const card = btn.closest('.fc-selector-card');
        if (card) card.classList.toggle('is-selected', isSelected);
      });
    }

    function getCheckedSimRadio() {
      if (!simDialog) return null;
      return simDialog.querySelector('input[type="radio"][name^="fc-sim-plan-"]:checked');
    }

    function updateSimModalTotal() {
      if (!simDialog) return;
      const totalElModal = simDialog.querySelector('[data-fc-sim-modal-total]');
      const totalCompareEl = simDialog.querySelector('[data-fc-sim-modal-total-compare]');
      const watchLineEl = simDialog.querySelector('[data-fc-sim-modal-watch-line]');
      const simLineEl = simDialog.querySelector('[data-fc-sim-modal-sim-line]');
      if (!totalElModal || !pendingAddBtn) return;
      const watch = toCents(pendingAddBtn.dataset.productPrice);
      const watchCompare = toCents(pendingAddBtn.dataset.productComparePrice);
      const radio = getCheckedSimRadio();
      const sim = radio ? toCents(radio.dataset.priceCents) : 0;
      const simPlanName = radio ? (radio.dataset.planName || '') : '';
      const watchTitle = pendingAddBtn.dataset.productName || pendingAddBtn.dataset.productTitle || 'Reloj Senior';

      if (watchLineEl) watchLineEl.textContent = watchTitle;
      if (simLineEl) simLineEl.textContent = simPlanName ? `Tarjeta SIM · Plan ${simPlanName}` : 'Tarjeta SIM';

      if (totalCompareEl) {
        const compareTotal = watchCompare > 0 ? (watchCompare + sim) : 0;
        if (compareTotal > watch + sim) {
          totalCompareEl.hidden = false;
          totalCompareEl.textContent = formatMoney(compareTotal);
        } else {
          totalCompareEl.hidden = true;
          totalCompareEl.textContent = '';
        }
      }

      totalElModal.textContent = formatMoney(watch + sim);
    }

    function openSimModal(btn) {
      if (!simDialog) return;
      pendingAddBtn = btn;
      const imgEl = simDialog.querySelector('[data-fc-sim-modal-img]');
      const titleEl = simDialog.querySelector('[data-fc-sim-modal-title]');
      const bulletsEl = simDialog.querySelector('[data-fc-sim-modal-bullets]');
      const modalImg = btn.dataset.productImageModal || btn.dataset.productImage || '';
      const popupTitle = btn.dataset.productPopupTitle || btn.dataset.productTitle || '';
      const popupBullets = btn.dataset.productPopupBullets || '';
      if (imgEl) {
        imgEl.src = modalImg || modalImageFallback;
        imgEl.alt = btn.dataset.productTitle || '';
      }
      if (titleEl) titleEl.textContent = popupTitle;
      if (bulletsEl) {
        bulletsEl.innerHTML = '';
        let bulletLines = [];

        bulletLines = extractBulletLines(popupBullets, []);

        if (bulletLines.length) {
          bulletLines.forEach((line) => {
            const li = document.createElement('li');
            li.textContent = line;
            bulletsEl.appendChild(li);
          });
        } else {
          const fallbackLines = [
            btn.dataset.productTitle || 'Reloj Senior',
            'Tarjeta SIM (plan a determinar)',
            'App'
          ];
          fallbackLines.forEach((line) => {
            const li = document.createElement('li');
            li.textContent = line;
            bulletsEl.appendChild(li);
          });
        }
      }
      if (!getCheckedSimRadio()) {
        const first = simDialog.querySelector('input[type="radio"][name^="fc-sim-plan-"]');
        if (first) first.checked = true;
      }
      updateSimModalTotal();
      simDialog.showModal();
    }

    function closeSimModal() {
      if (simDialog && simDialog.open) simDialog.close();
      pendingAddBtn = null;
    }

    function addSimpleSelection(addBtn) {
      const variantId = addBtn.dataset.variantId;
      const data = getButtonProductData(addBtn);
      selected.set(variantId, {
        key: data.key,
        variantId: data.variantId,
        title: data.title,
        price: data.unitPrice,
        unitPrice: data.unitPrice,
        quantity: 1,
        image: data.image,
        bullets: extractBulletLines(data.popupBullets, [data.title]),
        previewBullets: [data.productName],
        lines: data.lines
      });
    }

    function renderCheckoutPreviewModal() {
      if (!checkoutDialogListEl || !checkoutDialogTotalEl) return;
      checkoutDialogListEl.innerHTML = '';
      selected.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'fc-checkout-preview-item';

        const img = document.createElement('img');
        img.className = 'fc-checkout-preview-item__img';
        img.src = item.image || '';
        img.alt = item.title || '';

        const content = document.createElement('div');
        const title = document.createElement('p');
        title.className = 'fc-checkout-preview-item__title';
        title.textContent = item.title || '';

        const bullets = document.createElement('ul');
        bullets.className = 'fc-checkout-preview-item__bullets';
        (item.previewBullets || item.bullets || []).forEach((line) => {
          const bullet = document.createElement('li');
          bullet.textContent = line;
          bullets.appendChild(bullet);
        });

        content.appendChild(title);
        if (bullets.childElementCount) content.appendChild(bullets);

        const price = document.createElement('span');
        price.className = 'fc-checkout-preview-item__price';
        price.textContent = formatMoney(item.price || 0);

        li.appendChild(img);
        li.appendChild(content);
        li.appendChild(price);
        checkoutDialogListEl.appendChild(li);
      });

      checkoutDialogTotalEl.textContent = formatMoney(totalCents());
    }

    function openCheckoutPreviewModal() {
      if (!checkoutDialog) return;
      renderCheckoutPreviewModal();
      checkoutDialog.showModal();
    }

    function closeCheckoutPreviewModal() {
      if (checkoutDialog && checkoutDialog.open) checkoutDialog.close();
    }

    function handleSimConfirm() {
      if (!pendingAddBtn) return;
      const variantId = pendingAddBtn.dataset.variantId;
      const radio = getCheckedSimRadio();
      if (!radio || !variantId) return;
      const simId = radio.value;
      const plan = radio.dataset.sellingPlan || '';
      const selectionKey = buildSimSelectionKey(variantId, simId, plan);
      const simCents = toCents(radio.dataset.priceCents);
      const watchCents = toCents(pendingAddBtn.dataset.productPrice);
      const planName = radio.dataset.planName || '';
      const watchTitle = pendingAddBtn.dataset.productName || pendingAddBtn.dataset.productTitle || 'Producto';
      const title = planName ? watchTitle + ' · ' + planName : watchTitle + ' · SIM';
      const unitPrice = watchCents + simCents;
      const prev = selected.get(selectionKey);
      const nextQty = prev ? (Number(prev.quantity || 1) + 1) : 1;
      const bulletBase = extractBulletLines(
        pendingAddBtn.dataset.productPopupBullets || '',
        [watchTitle, 'Tarjeta SIM']
      );
      const bulletLines = [...bulletBase];
      if (planName) bulletLines.push(`Plan ${planName}`);
      const previewBullets = [
        watchTitle,
        planName ? `Tarjeta SIM · Plan ${planName}` : 'Tarjeta SIM'
      ];

      const lines = [
        { id: variantId, quantity: nextQty },
        { id: simId, quantity: nextQty, sellingPlan: plan }
      ];

      selected.set(selectionKey, {
        key: selectionKey,
        variantId,
        title,
        price: unitPrice * nextQty,
        unitPrice,
        quantity: nextQty,
        image: pendingAddBtn.dataset.productImage || '',
        bullets: bulletLines,
        previewBullets,
        lines
      });
      closeSimModal();
      render();
    }

    async function handleContinue(continueTarget) {
      if (!selected.size) return;

      continueTarget.disabled = true;
      continueTarget.textContent = 'Procesando...';

      try {
        const lines = cartPayloadItems();
        if (!lines.length) throw new Error('No hay líneas para añadir.');

        if (shouldClearCartBeforeContinue) {
          const clearRes = await fetch(cartPath('cart/clear.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin'
          });
          if (!clearRes.ok) {
            const clearErr = await clearRes.json().catch(() => ({}));
            throw new Error(clearErr.description || clearErr.message || 'No se pudo vaciar el carrito.');
          }
        }

        for (let i = 0; i < lines.length; i++) {
          const res = await fetch(cartPath('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [lines[i]] })
          });
          const body = await res.json().catch(() => ({}));
          if (!res.ok) {
            const msg =
              body.description ||
              body.message ||
              (body.errors && (typeof body.errors === 'string' ? body.errors : JSON.stringify(body.errors))) ||
              'No se pudo añadir un producto al carrito.';
            throw new Error(msg);
          }
        }

        window.location.href = cartPath('checkout');
      } catch (e) {
        continueTarget.disabled = false;
        continueTarget.textContent = continueLabel;
        alert(e.message || 'Ha ocurrido un error al continuar.');
      }
    }

    if (simDialog) {
      simDialog.addEventListener('change', (e) => {
        if (e.target && e.target.matches('input[type="radio"][name^="fc-sim-plan-"]')) updateSimModalTotal();
      });
      simDialog.addEventListener('close', () => {
        pendingAddBtn = null;
      });
      const closeBtn = simDialog.querySelector('[data-fc-sim-modal-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => closeSimModal());
      const confirmBtn = simDialog.querySelector('[data-fc-sim-modal-add]');
      if (confirmBtn) confirmBtn.addEventListener('click', handleSimConfirm);
    }

    if (checkoutDialog) {
      const closeBtn = checkoutDialog.querySelector('[data-fc-checkout-close]');
      const confirmBtn = checkoutDialog.querySelector('[data-fc-checkout-confirm]');
      if (closeBtn) closeBtn.addEventListener('click', closeCheckoutPreviewModal);
      if (confirmBtn) {
        confirmBtn.addEventListener('click', async () => {
          await handleContinue(confirmBtn);
        });
      }
    }

    root.addEventListener('click', async (event) => {
      const addBtn = event.target.closest('[data-fc-selector-add]');

      if (!addBtn) {
        const clickedCard = event.target.closest('.fc-selector-card');
        if (clickedCard) {
          if (event.target.closest('a')) event.preventDefault();
          const chooseBtnFromCard = clickedCard.querySelector('[data-fc-selector-add]');
          if (chooseBtnFromCard && !chooseBtnFromCard.disabled) chooseBtnFromCard.click();
          return;
        }
      }

      if (addBtn) {
        const variantId = addBtn.dataset.variantId;
        if (!variantId) return;

        if (addBtn.dataset.selectorSimModal === 'true' && simDialog) {
          openSimModal(addBtn);
          return;
        }

        if (selected.has(variantId)) {
          selected.delete(variantId);
          render();
          return;
        }

        addSimpleSelection(addBtn);
        render();
        return;
      }

      const removeBtn = event.target.closest('[data-fc-selector-remove]');
      if (removeBtn) {
        const rmId = removeBtn.getAttribute('data-fc-selector-remove') || removeBtn.dataset.fcSelectorRemove;
        if (rmId) selected.delete(rmId);
        render();
        return;
      }

      const continueTarget = event.target.closest('[data-fc-selector-continue]');
      if (!continueTarget) return;
      if (!selected.size) return;
      if (checkoutDialog) {
        openCheckoutPreviewModal();
        return;
      }
      await handleContinue(continueTarget);
    });

    render();
  }

  function initAllSelectors(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-fc-selector-root]').forEach(initFeaturedCollectionsSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSelectors(document);
    });
  } else {
    initAllSelectors(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllSelectors(event.target);
  });
})();
